<template>
  <div class="step-question-template weight-step-question">
    <div class="question-text" role="heading" aria-level="3" v-html="question.questionText"></div>
    <div class="question-description" v-html="question.questionDescription"></div>
    <WeightInput
      :measurement-systems="measurementSystems"
      :initial-value="question?.response?.weight"
      :style-props="weightInputStyle"
      @value-updated="onWeightValueUpdated"
    />
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import poster from "../../mixins/poster";
import { MeasurementSystem, WeightInputStyleProps, WeightQuestion } from "../../types";
import WeightInput, { WeightValueUpdatedEvent } from "../common/bmi/WeightInput.vue";

export default Vue.extend({
  components: {
    WeightInput,
  },
  mixins: [poster],
  props: {
    question: { type: Object as PropType<WeightQuestion>, required: true },
    measurementSystems: { type: Array as PropType<MeasurementSystem[]>, required: true },
    weightInputStyle: { type: Object as PropType<WeightInputStyleProps>, required: true },
    showRequired: { required: true },
  },
  data() {
    return {
      isWeightComplete: false,
      isWeightValid: false,
    };
  },
  methods: {
    updateNextButton() {
      this.$emit("update-next-button-status", this.isComplete && this.isValid);
    },
    onWeightValueUpdated(event: WeightValueUpdatedEvent) {
      this.isWeightComplete = event.isComplete;

      this.isWeightValid = event.isValid;

      this.question.response = {
        ...this.question.response,
        weight: event.value,
      };

      this.updateNextButton();
    },
  },
  computed: {
    isComplete: function () {
      return this.isWeightComplete;
    },
    isValid: function () {
      return this.isWeightValid;
    },
  },
});
</script>
